import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'

/**
 * @desc 用法
 * @desc 按钮部分
   <ReminderBtn
    lang={this.state.lang}
    slotButtonComp={() => { return (<Element></Element>) }}
    slotContentComp={this.contentComp} />
 * @desc
   contentComp(open, close, lang) {
     return (
       <div className="" onClick={() => { close() }}>
       </div>
     )
   }
 */
let timer = null

@inject('store')
@observer

export default class extends Component {
  constructor(props) {
    super(props)
  }


  async componentWillMount() {
    // let { language } = this.props.location.query
    // language = getlang(language)
    // console.log('language', language)
    // // lang 文字对象
    // // language 语言种类 (zh/ar/en)
    // this.setState({
    //   lang: setlang(language, langM),
    //   language: language,
    // })
    // let uid = await setUidToken(this.props.location.query)
    // console.log(uid, 'uid')
    // await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // 用户id
    this.setState({
      uid: uid
    })
  }

  componentDidMount() {

  }

  state = {
    ruleState: false,
    num: 0,           // 0 默认 - 1 大 2 小
  }

  open() {
    console.log('我点击了规则按钮')
    document.getElementsByTagName('html')[0].className = "fixDiv"
    this.setState({
      ruleState: true,
      num: 1
    })
  }

  async close() {
    document.getElementsByTagName('html')[0].className = ""
    const times = this.props.time || 0.3
    await this.setState({
      num: 2
    })
    timer = await setTimeout(() => {
      this.setState({ ruleState: false })
      clearTimeout(timer)
    }, (times * 1000));
  }

  componentWillUnmount() {
    clearTimeout(timer)
  }

  render() {
    // 1. 外部传入一个函数，内部向外暴露 open 和 close 方法
    // let comp = (open,close) => { return (<div>1</div>) }
    // <PopUp slotButtonComp={comp} />
    // <PopUp slotButtonComp={(e) => comp} />

    const { slotButtonComp, slotContentComp, lang } = this.props
    return (
      <div className='rule-component-button'>
        <div className="rule-component-button-click">
          {slotButtonComp && slotButtonComp(() => { this.open() }, () => { this.close() }, lang)}
        </div>
        <div className="rule-component-show" style={{ display: `${this.state.ruleState ? "block" : "none"}` }}>
          <div className="rule-component-mask" onClick={() => { this.close() }}></div>
          <div
            className={`rule-component-content-wrap ${this.state.num == 1 ? "comp-big" : ""} ${this.state.num == 2 ? "comp-small" : ""}`}
            style={{ animationDuration: `${this.props.time || "0.3"}s` }}>
            {slotContentComp && slotContentComp(() => { this.open() }, () => { this.close() }, lang)}
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// src/component/showTost/index.js